import { apiClient } from "@/shared/api/client";

export interface CreateFranchiseInquiryRequest {
  name: string;
  phone_number: string;
  description: string;
  has_existing_store: boolean;
  agree_terms: boolean;
  agree_marketing: boolean;
}

export interface FranchiseInquiryResponse {
  success: boolean;
  data?: {
    id: string;
  };
  message: string;
}

export async function createFranchiseInquiry(
  data: CreateFranchiseInquiryRequest
): Promise<FranchiseInquiryResponse> {
  const response = await apiClient.post<FranchiseInquiryResponse>(
    "/v1/franchise-inquiry",
    data
  );
  return response.data;
}
